var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalValueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_140",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E86046"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.53341 24L2.66675 22.1333L12.5334 12.2L17.8667 17.5333L24.8001 10.6667H21.3334V8H29.3334V16H26.6667V12.5333L17.8667 21.3333L12.5334 16L4.53341 24Z",
    fill: "#FB2648"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalValueIcon);
export default __webpack_public_path__ + "static/media/total-value-icon.b328c74fc696e2458db1e6d8a5c92a84.svg";
export { ForwardRef as ReactComponent };